// import React, { useState, useRef, useEffect } from 'react';
// import logo from '../AdminDashboard/assets/shared image.jpeg';
// import '../AdminDashboard/css/Topbar.css';
// import { IoMenu } from 'react-icons/io5';
// import { FiUser } from 'react-icons/fi';
// import { useNavigate } from 'react-router-dom';
// import { IoMdNotificationsOutline, IoMdClose } from "react-icons/io";
// import { getWithTokenAPI, putAPI } from "../../src/utils/Api";

// function Topbar({ toggleSidebar, adminName, onLogout }) {
//     const navigate = useNavigate();
//     const [notifications, setNotifications] = useState([]);
//     const [unreadCount, setUnreadCount] = useState(0);
//     const [showNotificationPanel, setShowNotificationPanel] = useState(false);
//     const [activeNotification, setActiveNotification] = useState(null);
//     const panelRef = useRef(null);
//     const token = localStorage.getItem("token");

//     const handleProfileClick = () => {
//         navigate('/backoffice/profile');
//     };

//     const toggleNotificationPanel = () => {
//         setShowNotificationPanel(!showNotificationPanel);
//     };

//     const handleNotificationClick = async (notification) => {
//         setActiveNotification(notification._id);
//         if (!notification.is_read) {
//             const updatedNotifications = notifications.map(n => 
//                 n._id === notification._id ? { ...n, is_read: true } : n
//             );
//             setNotifications(updatedNotifications);
//             setUnreadCount(prev => prev - 1);

//             try {
//                 await putAPI(token, `/mark-read/${notification._id}`);
//             } catch (err) {
//                 console.error("Failed to mark notification as read:", err);
//                 // Revert if API fails
//                 const originalNotifications = notifications.map(n => 
//                     n._id === notification._id ? { ...n, is_read: false } : n
//                 );
//                 setNotifications(originalNotifications);
//                 setUnreadCount(prev => prev + 1);
//             }
//         }

//         // Navigation logic
//         const codeToPathMap = {
//             "1037": "/backoffice/newsletter",
//             "1039": "/backoffice/enquirymanagement",
//             "1041": "/backoffice/sellermanagement",
//             "1043": "/backoffice/category",
//             "1045": "/backoffice/productmanagement",
//             "1099":"/backoffice/order"
//         };

//         const path = codeToPathMap[notification.message_code] || "/backoffice/notifications";
//         setShowNotificationPanel(false);
//         navigate(path);
//     };

//     const fetchNotifications = async () => {
//         try {
//             const res = await getWithTokenAPI(token, "/notification/admin-app-notification");
//             setNotifications(res.notification || []);
//             setUnreadCount(res.notification.filter(n => !n.is_read).length);
//         } catch (error) {
//             console.error("Failed to load notifications:", error);
//         }
//     };

//     useEffect(() => {
//         fetchNotifications();

//         const handleClickOutside = (event) => {
//             if (panelRef.current && !panelRef.current.contains(event.target)) {
//                 setShowNotificationPanel(false);
//             }
//         };

//         document.addEventListener("mousedown", handleClickOutside);
//         return () => {
//             document.removeEventListener("mousedown", handleClickOutside);
//         };
//     }, [token]);

//     const formatDate = (dateString) => {
//         if (!dateString) return '';
//         const now = new Date();
//         const date = new Date(dateString);
//         const diffInSeconds = Math.floor((now - date) / 1000);

//         if (diffInSeconds < 60) return `${diffInSeconds} seconds ago`;
//         if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} minutes ago`;
//         if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hours ago`;
//         return `${Math.floor(diffInSeconds / 86400)} days ago`;
//     };

//     return (
//         <div className="container-fluid header1">
//             <div className="row align-items-center py-2 px-3 Topside01 border">
//                 <div className="col-md-6 d-flex align-items-center logo01">
//                     <IoMenu
//                         className="me-3 menu-icon"
//                         onClick={toggleSidebar}
//                         style={{ cursor: 'pointer', fontSize: '1.5rem',position:'relative',right:"5px" }}
//                     />
//                     <div style={{ marginLeft: '-17px' }}>
//                         <img
//                             src={logo}
//                             alt="company_logo"
//                             className="logo"
//                             onClick={() => navigate('/backoffice/')}
//                         />
//                     </div>
//                 </div>

//                 <div className='col-md-3 d-flex justify-content-end align-items-center' style={{gap: '18px'}}>
//                     <div className="notification-container position-relative">
//                         <div
//                             className="d-flex align-items-center notification-icon-wrapper"
//                             onClick={toggleNotificationPanel}
//                             style={{ cursor: 'pointer' }}
//                         >
//                             <IoMdNotificationsOutline className="fs-4" />
//                             {unreadCount > 0 && (
//                                 <span className="badge bg-danger rounded-pill notification_count_icon">{unreadCount}</span>
//                             )}
//                         </div>
//                     </div>
//                     <div
//                         className="UserProfileSection"
//                         style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
//                         onClick={handleProfileClick}
//                     >
//                         <FiUser className="UserIcon" />
//                         <span className="UserName ms-2 d-none d-sm-inline">{adminName}</span>
//                     </div>
//                 </div>
//             </div>

//             <div
//                 ref={panelRef}
//                 className={`notification-panel ${showNotificationPanel ? 'open' : ''}`}
//             >
//                 <div className="notification-panel-header">
//                     <h5>Notifications</h5>
//                     <div className="d-flex align-items-center">
//                         {/* <span className="badge bg-primary me-2">{notifications.length} total</span> */}
//                         {/* <span className="badge bg-danger me-2">{unreadCount} unread</span> */}
//                         <IoMdClose
//                             className="close-icon"
//                             onClick={() => setShowNotificationPanel(false)}
//                         />
//                     </div>
//                 </div>
//                 <div className="notification-panel-body">
//                     {notifications.length > 0 ? (
//                         notifications.map((notification) => (
//                             <div
//                                 key={notification._id}
//                                 className={`notification-panel-item 
//                                     ${!notification.is_read ? 'unread' : 'read'}
//                                     ${activeNotification === notification._id ? 'active' : ''}
//                                 `}
//                                 onClick={() => handleNotificationClick(notification)}
//                             >
//                                 <div className="notification-content">
//                                     <h6>{notification.heading || 'Notification'}</h6>
//                                     <p>{notification.content.replace(/<[^>]*>/g, '') || 'No content available'}</p>
//                                     <small>{formatDate(notification.createdAt)}</small>
//                                 </div>
//                                 {!notification.is_read && (
//                                     <span className="unread-dot"></span>
//                                 )}
//                             </div>
//                         ))
//                     ) : (
//                         <div className="notification-panel-item empty">
//                             <p>No notifications available</p>
//                         </div>
//                     )}
//                 </div>
//             </div>

//             {showNotificationPanel && (
//                 <div
//                     className="notification-overlay"
//                     onClick={() => setShowNotificationPanel(false)}
//                 ></div>
//             )}
import React, { useState, useRef, useEffect } from 'react';
import logo from '../AdminDashboard/assets/dextra-logo.jpeg';
import '../AdminDashboard/css/Topbar.css';
import { IoMenu } from 'react-icons/io5';
import { FiUser } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { IoMdNotificationsOutline, IoMdClose } from "react-icons/io";
import { getWithTokenAPI, putAPI } from "../../src/utils/Api";

function Topbar({ toggleSidebar, adminName, onLogout }) {
    const navigate = useNavigate();
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [showNotificationPanel, setShowNotificationPanel] = useState(false);
    const [activeNotification, setActiveNotification] = useState(null);
    const panelRef = useRef(null);
    const token = localStorage.getItem("token");

    const handleProfileClick = () => {
        navigate('/backoffice/profile');
    };

    const toggleNotificationPanel = () => {
        setShowNotificationPanel(!showNotificationPanel);
    };

    const handleNotificationClick = async (notification) => {
        setActiveNotification(notification._id);
        if (!notification.is_read) {
            const updatedNotifications = notifications.map(n => 
                n._id === notification._id ? { ...n, is_read: true } : n
            );
            setNotifications(updatedNotifications);
            setUnreadCount(prev => prev - 1);

            try {
                await putAPI(token, `/mark-read/${notification._id}`);
            } catch (err) {
                console.error("Failed to mark notification as read:", err);
                // Revert if API fails
                const originalNotifications = notifications.map(n => 
                    n._id === notification._id ? { ...n, is_read: false } : n
                );
                setNotifications(originalNotifications);
                setUnreadCount(prev => prev + 1);
            }
        }

        // Navigation logic
        const codeToPathMap = {
            "1037": "/backoffice/newsletter",
            "1039": "/backoffice/enquirymanagement",
            "1041": "/backoffice/sellermanagement",
            "1043": "/backoffice/category",
            "1045": "/backoffice/productmanagement",
            "1099":"/backoffice/order",
            "1052":"/backoffice/farmprecision",
            "1051":"/backoffice/soiltesting",
            "1053":"/backoffice/dronebooking"
        };

        const path = codeToPathMap[notification.message_code] || "/backoffice/notifications";
        setShowNotificationPanel(false);
        navigate(path);
    };

    const fetchNotifications = async () => {
        try {
            const res = await getWithTokenAPI(token, "/notification/admin-app-notification");
                        const uniqueNotifications = [];
            const seenNotifications = new Set();
            
            res.notification.forEach(notification => {
                const notificationKey = `${notification.content}_${Math.floor(new Date(notification.createdAt).getTime() / 5000)}`;
                
                if (!seenNotifications.has(notificationKey)) {
                    seenNotifications.add(notificationKey);
                    uniqueNotifications.push(notification);
                }
            });
            setNotifications(uniqueNotifications || []);
            setUnreadCount(uniqueNotifications.filter(n => !n.is_read).length);
        } catch (error) {
            console.error("Failed to load notifications:", error);
        }
    };

    useEffect(() => {
        fetchNotifications();

        const handleClickOutside = (event) => {
            if (panelRef.current && !panelRef.current.contains(event.target)) {
                setShowNotificationPanel(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [token]);

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const now = new Date();
        const date = new Date(dateString);
        const diffInSeconds = Math.floor((now - date) / 1000);

        if (diffInSeconds < 60) return 'Just now';
        if (diffInSeconds < 3600) {
            const minutes = Math.floor(diffInSeconds / 60);
            return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
        }
        if (diffInSeconds < 86400) {
            const hours = Math.floor(diffInSeconds / 3600);
            return `${hours} hour${hours > 1 ? 's' : ''} ago`;
        }
        
        const days = Math.floor(diffInSeconds / 86400);
        return `${days} day${days > 1 ? 's' : ''} ago`;
    };

    return (
        <div className="container-fluid header1">
            <div className="row align-items-center py-2 px-3 Topside01 border">
                <div className="col-md-6 d-flex align-items-center logo01">
                    <IoMenu
                        className="me-3 menu-icon"
                        onClick={toggleSidebar}
                        style={{ cursor: 'pointer', fontSize: '1.5rem',position:'relative',right:"5px" }}
                    />
                    <div style={{ marginLeft: '-17px' }}>
                        <img
                            src={logo}
                            alt="company_logo"
                            className="logo"
                            onClick={() => navigate('/backoffice/')}
                        />
                    </div>
                </div>

                <div className='col-md-3 d-flex justify-content-end align-items-center' style={{gap: '18px'}}>
                    <div className="notification-container position-relative">
                        <div
                            className="d-flex align-items-center notification-icon-wrapper"
                            onClick={toggleNotificationPanel}
                            style={{ cursor: 'pointer' }}
                        >
                            <IoMdNotificationsOutline className="fs-4" />
                            {unreadCount > 0 && (
                                <span className="badge bg-danger rounded-pill notification_count_icon">{unreadCount}</span>
                            )}
                        </div>
                    </div>
                    <div
                        className="UserProfileSection"
                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                        onClick={handleProfileClick}
                    >
                        <FiUser className="UserIcon" />
                        <span className="UserName ms-2 d-none d-sm-inline">{adminName}</span>
                    </div>
                </div>
            </div>

            <div
                ref={panelRef}
                className={`notification-panel ${showNotificationPanel ? 'open' : ''}`}
            >
                <div className="notification-panel-header">
                    <h5>Notifications</h5>
                    <div className="d-flex align-items-center">
                        {/* <span className="badge bg-primary me-2">{notifications.length} total</span> */}
                        {/* <span className="badge bg-danger me-2">{unreadCount} unread</span> */}
                        <IoMdClose
                            className="close-icon"
                            onClick={() => setShowNotificationPanel(false)}
                        />
                    </div>
                </div>
                <div className="notification-panel-body">
                    {notifications.length > 0 ? (
                        notifications.map((notification) => (
                            <div
                                key={notification._id}
                                className={`notification-panel-item 
                                    ${!notification.is_read ? 'unread' : 'read'}
                                    ${activeNotification === notification._id ? 'active' : ''}
                                `}
                                onClick={() => handleNotificationClick(notification)}
                            >
                                <div className="notification-content">
                                    <h6>{notification.heading || 'Notification'}</h6>
                                    <p>{notification.content.replace(/<[^>]*>/g, '') || 'No content available'}</p>
                                    <small>{formatDate(notification.createdAt)}</small>
                                </div>
                                {!notification.is_read && (
                                    <span className="unread-dot"></span>
                                )}
                            </div>
                        ))
                    ) : (
                        <div className="notification-panel-item empty">
                            <p>No notifications available</p>
                        </div>
                    )}
                </div>
            </div>

            {showNotificationPanel && (
                <div
                    className="notification-overlay"
                    onClick={() => setShowNotificationPanel(false)}
                ></div>
            )}
        </div>
    );
}

export default Topbar;